import React, { ReactElement, useEffect, useRef, useState } from 'react';
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import { DEFAULT_COORDINATES, POSTAL_CODE } from '../../../shared/constants/commonConstants';
import MapSearchBox from './MapSearchBox';

const Map = withGoogleMap(({ lat, lng, inputTextValue, setInputTextAsAddress, setPincode, getLatLng, searchBox }: any): ReactElement => {
  const refs = {} as any;
  const [inputText, setInputText] = useState(inputTextValue);
  const [latLong, setLatLong] = useState({ lat, lng });
  const ref = useRef({ isChangeLoc: false });

  useEffect((): void => {
    if (setInputTextAsAddress) {
      setInputTextAsAddress(inputText);
    }
    // eslint-disable-next-line
  }, [inputText]);

  useEffect((): void => {
    setInputText(inputTextValue);
    // eslint-disable-next-line
  }, [inputTextValue]);

  useEffect((): void => {
    if (latLong.lat !== DEFAULT_COORDINATES.lat && latLong.lng !== DEFAULT_COORDINATES.lng) {
      setLocationByLatLng(latLong);
    }
    if (getLatLng) {
      getLatLng(latLong);
    }
    // eslint-disable-next-line
  }, [latLong]);

  // tslint:disable-next-line: no-shadowed-variable
  const onMarkerClick = ({ latLng: { lat, lng } }: any): void => {
    setLatitudeLongitude(lat(), lng());
    ref.current.isChangeLoc = false;
  };

  // tslint:disable-next-line: no-shadowed-variable
  const onDragEnd = ({ latLng: { lat, lng } }: any): void => {
    setLatitudeLongitude(lat(), lng());
    ref.current.isChangeLoc = false;
  };

  const setLocationByLatLng = (latlng: any): void => {
    new google.maps.Geocoder()
      .geocode({ location: latlng }, (results: any[], status: string): void => {
        if (status === 'OK' && (results && results.length > 0)) {
          // if (!ref.current.isChangeLoc) {
          //   setSearchBoxText(results[0].formatted_address);
          // }
          results[0].address_components.map((v: any, i: number, a: any): void => {
            if (i === a.length - 1 && v.types[0] === POSTAL_CODE) {
              if (setPincode) {
                setPincode(v.long_name);
              }
            }
            return v;
          });
        }
      });
  };

  const setSearchBoxText = (text: string): void => {
    setInputText(text);
  };

  const setLatitudeLongitude = (latitude: number, longitude: number): void => {
    setLatLong({ lat: latitude, lng: longitude });
  };

  const onSearchBoxMounted = (reference: any): any => {
    refs.searchBox = reference;
  };

  const onPlacesChanged = (): any => {
    const { formatted_address, geometry } = refs.searchBox.getPlaces()[0];
    setSearchBoxText(formatted_address);
    setLatitudeLongitude(geometry.location.lat(), geometry.location.lng());
    ref.current.isChangeLoc = true;
  };

  return (
    <GoogleMap
      defaultZoom={11}
      defaultCenter={latLong}
      center={latLong}
      options={{ draggable: searchBox ? true : false }}
    >
      {searchBox ? (
        <>
          <MapSearchBox
            inputText={inputText}
            onPlacesChanged={onPlacesChanged}
            onSearchBoxMounted={onSearchBoxMounted}
            setSearchBoxText={setSearchBoxText} />
          <Marker onClick={onMarkerClick} onDragEnd={onDragEnd} draggable={true}
            position={latLong}
          />
        </>
      ) : (
          <Marker position={latLong}
          />
        )}

    </GoogleMap>
  );
},
);

export default Map;
